<section id="dynamic-ngx-table">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <!-- NGX DATATABLE -->
            <ngx-datatable
              class="bootstrap core-bootstrap"
              [rows]="dataList"
              [columnMode]="ColumnMode.force"
              [headerHeight]="50"
              [footerHeight]="50"
              rowHeight="auto"
              [limit]="limit"
              [scrollbarH]="true"
            >
              <!-- S.NO COLUMN -->
              <ngx-datatable-column name="S.No" [width]="60">
                <ng-template
                  ngx-datatable-cell-template
                  let-rowIndex="rowIndex"
                >
                  {{ (page - 1) * limit + rowIndex + 1 }}
                </ng-template>
              </ngx-datatable-column>

              <!-- DYNAMIC COLUMNS -->
              <ngx-datatable-column
                *ngFor="let field of listFields"
                [name]="field.fieldName"
                [prop]="field.field"
                [width]="field.width || 160"
              >
                <ng-template ngx-datatable-cell-template let-row="row">
                  <ng-container [ngSwitch]="field.field">
                    <!-- IMAGE CASE -->
                    <img
                      *ngSwitchCase="'icon'"
                      class="img-fluid rounded-circle"
                      style="max-height: 40px"
                      [src]="
                        row.icon
                          ? env.url + '/file/billerIcons/' + row.icon
                          : 'assets/images/no-img.jpg'
                      "
                    />

                    <!-- FULL NAME -->
                    <span *ngSwitchCase="'full_name'">
                      {{ row?.full_name | titlecase }}
                    </span>

                    <!-- COMBINED NAME -->
                    <span *ngSwitchCase="'first_name'">
                      {{
                        hp.constructName(
                          row.first_name,
                          row.middle_name,
                          row.last_name
                        )
                      }}
                    </span>

                    <!-- TRIMMED TEXT -->
                    <span *ngSwitchCase="'blr_name'">
                      {{ hp.trimString(row?.blr_name, 25) }}
                    </span>

                    <span *ngSwitchCase="'quintus_transaction_id'">
                      <a [routerLink]="viewRoutePath + '/' + row[editKey]">
                        {{ GetFieldByIndex(row, field.field) }}
                      </a>
                    </span>

                    <!-- MONEY FORMAT -->
                    <span *ngSwitchCase="'transactionAmount'"
                      >₹ {{ GetFieldByIndex(row, field.field) }}</span
                    >
                    <span *ngSwitchCase="'walletHistory.previous_balance'"
                      >₹ {{ GetFieldByIndex(row, field.field) }}</span
                    >
                    <span *ngSwitchCase="'walletHistory.transactionType'">{{
                      GetFieldByIndex(row, field.field) | titlecase
                    }}</span>
                    <span *ngSwitchCase="'walletHistory.amount'"
                      >₹ {{ GetFieldByIndex(row, field.field) }}</span
                    >
                    <span *ngSwitchCase="'walletHistory.updated_balance'"
                      >₹ {{ GetFieldByIndex(row, field.field) }}</span
                    >
                    <span *ngSwitchCase="'walletHistory.updated_payout_balance'"
                      >₹ {{ GetFieldByIndex(row, field.field) }}</span
                    >
                    <span *ngSwitchCase="'customerCommission'"
                      >₹ {{ GetFieldByIndex(row, field.field) }}</span
                    >
                    <span *ngSwitchCase="'serviceCharge'"
                      >₹ {{ GetFieldByIndex(row, field.field) }}</span
                    >

                    <!-- DATES -->
                    <span *ngSwitchCase="'created_at'">
                      {{ GetFieldByIndex(row, field.field) | date : "medium" }}
                    </span>

                    <!-- UPDATED BY -->
                    <span *ngSwitchCase="'updated_by'">
                      QT-{{
                        row?.updated_by === "self" ? 100000 : row?.updated_by
                      }}
                    </span>

                    <span *ngSwitchCase="'created_by'">
                      QT-{{
                        row?.created_by === "self" ? 100000 : row?.created_by
                      }}
                    </span>

                    <span *ngSwitchCase="'updated_at'">
                      {{ GetFieldByIndex(row, field.field) | date : "medium" }}
                    </span>

                    <!-- QUINTUS ID -->
                    <span *ngSwitchCase="'user.quintus_id'">
                      QT-{{ GetFieldByIndex(row, field.field) }}
                    </span>

                    <!-- STATUS BADGE -->
                    <ng-container *ngSwitchCase="'status'">
                      <span
                        class="badge badge-pill text-capitalize"
                        [ngClass]="{
                          'badge-success': row.status === 'success',
                          'badge-warning': row.status === 'initiated',
                          'badge-danger': row.status === 'failed & refund',
                          'badge-info': row.status === 'pending'
                        }"
                      >
                        {{ row.status }}
                      </span>
                    </ng-container>

                    <!-- DEFAULT -->
                    <span *ngSwitchDefault>
                      {{ GetFieldByIndex(row, field.field) }}
                    </span>
                  </ng-container>
                </ng-template>
              </ngx-datatable-column>

              <!-- ACTION COLUMN -->
              <ngx-datatable-column
                name="Actions"
                [width]="160"
                *ngIf="
                  showAction?.edit || showAction?.view || showAction?.delete
                "
              >
                <ng-template ngx-datatable-cell-template let-row="row">
                  <button
                    *ngIf="showAction.edit"
                    class="btn btn-primary btn-sm mx-1"
                    [routerLink]="editRoutePath + '/' + row[editKey]"
                  >
                    <i class="ft-edit"></i>
                  </button>

                  <button
                    *ngIf="showAction.view"
                    class="btn btn-success btn-sm mx-1"
                    [routerLink]="viewRoutePath + '/' + row[editKey]"
                  >
                    <i class="ft-eye"></i>
                  </button>

                  <button
                    *ngIf="showAction.delete"
                    class="btn btn-danger btn-sm mx-1"
                    (click)="deleteService(row[editKey])"
                  >
                    <i class="ft-trash-2"></i>
                  </button>
                </ng-template>
              </ngx-datatable-column>
            </ngx-datatable>

            <!-- PAGINATION -->
            <div
              class="d-flex justify-content-between align-items-center mt-2 flex-wrap"
            >
              <!-- PAGE BUTTONS -->
              <div class="d-flex align-items-center mb-2">
                <button
                  class="btn btn-primary btn-sm mx-1"
                  [disabled]="page === 1"
                  (click)="previousPage()"
                >
                  Previous
                </button>

                <span> Page {{ page }} of {{ totalPages }} </span>

                <button
                  class="btn btn-primary btn-sm mx-1"
                  [disabled]="page === totalPages"
                  (click)="nextPage()"
                >
                  Next
                </button>
              </div>

              <!-- PAGE SIZE -->
              <div class="d-flex align-items-center mb-2">
                <label class="mr-2 mb-0">Rows per page:</label>

                <select
                  [(ngModel)]="limit"
                  (change)="limitUpdate()"
                  class="form-control w-auto"
                >
                  <option *ngFor="let s of pageSizes" [value]="s">
                    {{ s }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
